import _ from "lodash";
import store from "../store/store";
export default class DataSettings {
  // Defaults settings for each component
  static defaultConfig = {
    recentyear: 0,
    startyear: 0,
    stopyear: 0
  };
  static defaultFields = {
    fieldBookmarks: {},
    fieldComments: {}
  };
  static defaultFocus = {
    layout: [],
    lastQuery: null
  };
  static defaultStory = {
    scrolled: 0,
    inFocus: "topic",
    sortType: null,
    sortDir: null,
    bookmarks: [],
    currentPage: 1,
    search: ""
  };
  static defaultFilters = {
    topic: null,
    filters: [],
    autoFiltCats: []
  };

  // Get settings of required key
  static getSettings(key) {
    const storedSettings = JSON.stringify(store.state.setting.dataSettings);
    let object = JSON.parse(storedSettings);
    return _.get(object, key);
  }

  // Set settings for a unique key
  static setSettings(key, settings) {
    //console.log(key, settings);
    const storedSettings = JSON.stringify(store.state.setting.dataSettings);
    let object = JSON.parse(storedSettings);
    if (key === "root") {
      object.exploreConfig = this.loadDefaultConfig(object);
      object.fields = this.loadDefaultFields(object);
      object.focus = this.loadDefaultFocus(object);
      object.story = this.loadDefaultStory(object);
      object.filters = this.loadDefaultFilters(object);
      store.dispatch("saveDataSettings", object);
    }
    else if(key.split(".")[0] === "story") {
      _.set(object, key, settings);
      if(key.split(".")[1] === "bookmarks"){
        store.dispatch("saveDataSettings", object);
      }
      else{
        store.dispatch("saveUserSettings", object);
      }
    }
    else {
      _.set(object, key, settings);
      //console.log("Saving Settings", object, key, settings);
      store.dispatch("saveDataSettings", object);
    }
  }

  // Determining actual state of settings
  static loadDefaultConfig(settings) {
    return settings.exploreConfig ? settings.exploreConfig : this.defaultConfig;
  }
  static loadDefaultFields(settings) {
    return settings.fields ? settings.fields : this.defaultFields;
  }
  static loadDefaultFocus(settings) {
    return settings.focus ? settings.focus : this.defaultFocus;
  }
  static loadDefaultStory(settings) {
    return settings.story ? settings.story : this.defaultStory;
  }
  static loadDefaultFilters(settings) {
    return settings.filters ? settings.filters : this.defaultFilters;
  }
}
